import React from "react";

import StyledButton from "../styledButton/StyledButton";

import styles from "./PaymentsBar.module.scss";

type PaymentsBarProps = {
  currency: string;
  price: number;
  buttonText: string;
  onClick: () => void;
  available?: boolean;
};

export default function PaymentsBar({
  currency,
  price,
  buttonText,
  onClick,
  available = true,
}: PaymentsBarProps) {
  const priceText = `${currency}: $${price}`;
  const quantity = available ? "Limited Quantity" : "Sold Out";

  return (
    <div className={styles.paymentsBarContainer}>
      <div className={styles.priceContainer}>
        <p className={styles.priceText}>{priceText}</p>
        <p className={styles.priceDetailsText}>• {quantity}</p>
      </div>
      <StyledButton
        baseClassname={styles.button}
        disabledClassname={styles.button}
        onClick={onClick}
        text={buttonText}
        type={"button"}
        disabled={!available}
      />
    </div>
  );
}
